import DgTableV1 from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgTableV1.install = function (Vue) {
  Vue.component(DgTableV1.name, DgTableV1)
}
export default DgTableV1

export { DgTableV1 }
